import TableHeader from '../../../../models/TableHeader';
import TabModel from '../../../../models/TabModel';
import { getMoneyMask, toBrazilianDate } from '../../../../helpers';

export const tabItems = [
  new TabModel(
    'detalhes-proposta-tab',
    0,
    'Detalhes da Proposta',
    'scrollable-auto-tabpanel',
  ),
  new TabModel(
    'detalhes-processo-tab',
    1,
    'Detalhes do Processo',
    'scrollable-auto-tabpanel',
  ),
  new TabModel(
    'lista-titulos-tab',
    2,
    'Lista de Títulos',
    'scrollable-auto-tabpanel',
  ),
  new TabModel(
    'lista-parcelas-tab',
    3,
    'Parcelas',
    'scrollable-auto-tabpanel',
  ),
];

export const formaPgtoString = (value) => {
  if (value === 0) return 'Boleto';
  if (value === 1) return 'Pix';
  if (value === 2) return 'Cartão';
  if (value === 5) return 'Dinheiro';
  if (value === 6) return 'Cheque';
  return '-';
};

export const buildTable = content => ({
  id: content.numeroTitulo || content.sequencia,
  values: {
    pertencenteAoAcordo: content.pertencenteAoAcordo,
    sequencia: content.sequencia,
    tipoTitulo: content.tipoTitulo,
    numeroTitulo: content.numeroTitulo,
    dataVencimento: content.dataVencimento
      ? toBrazilianDate(content.dataVencimento)
      : '-',
    atraso: content.atraso,
    valorOriginal: getMoneyMask(content.valorOriginal || 0),
    saldoOriginal: getMoneyMask(content.saldoOriginal || 0),
  },
});

export const tableColumns = [
  new TableHeader({
    id: 'sequencia',
    label: 'Seq.',
    alignCell: 'center',
    width: 55,
    maxWidth: 55,
  }),
  new TableHeader({
    id: 'tipoTitulo',
    label: 'Tipo',
    alignCell: 'center',
    width: 65,
    maxWidth: 65,
  }),
  new TableHeader({
    id: 'numeroTitulo',
    label: 'Número',
    alignCell: 'center',
    width: 95,
    maxWidth: 95,
  }),
  new TableHeader({
    id: 'dataVencimento',
    label: 'Vencimento',
    alignCell: 'center',
    width: 100,
    maxWidth: 100,
  }),
  new TableHeader({
    id: 'atraso',
    label: 'Atraso',
    width: 75,
    maxWidth: 75,
    alignCell: 'center',
  }),
  new TableHeader({
    id: 'valorOriginal',
    label: 'Valor Original',
    width: 120,
    maxWidth: 120,
    alignCell: 'flex-end',
  }),
  new TableHeader({
    id: 'saldoOriginal',
    label: 'Saldo Original',
    width: 120,
    maxWidth: 120,
    alignCell: 'flex-end',
  }),
];
